import React from 'react'
import BulkPermissionsUpdate from 'views/settings/components/bulkUpdates/components/permissions'
import BulkTextUpdate from 'views/settings/components/bulkUpdates/components/text'
import { SETTINGS_CANVAS } from 'views/settings/components/settingsCard'

/**
 * Changes across many of the hub's documents and tables at once, as the Styling page's cards: replacing text
 * in documents, and replacing the permissions of chosen documents, tables or views.
 */
const BulkUpdates: React.FC = () => (
  <div className={`w-full min-h-full overflow-auto ${SETTINGS_CANVAS}`}>
    <div className="mx-auto flex max-w-[720px] flex-col gap-4">
      <BulkTextUpdate />
      <BulkPermissionsUpdate />
    </div>
  </div>
)

export default BulkUpdates
